import fetch from 'services/request';
import { IApiCreateChannelData, IApiGetChannelsParam } from '../interfaces/api';

// const baseURL = 'api/v1/:merchant_code/demoData';

export const getDemoData = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ data: { data: [] } });
    }, 1000);
  });
  // return fetch({
  //   method: 'get',
  //   url: `${baseURL}/getDemoData`,
  //   params: params as any
  // });
};

const getListChannels = (params: IApiGetChannelsParam) => {
  return fetch({
    method: 'get',
    url: '/api/v1/manage-channel/list',
    params,
  });
};

const createChannel = (data: IApiCreateChannelData) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-channel/create',
    body: data,
  });
};

const deleteChannel = (channelId: string) => {
  return fetch({
    method: 'delete',
    url: `/api/v1/manage-channel/delete/${channelId}`,
  });
};

const getListLayouts = () => {
  return fetch({
    method: 'get',
    url: '/api/v1/manage-channel/list-layouts',
  });
};

const getListMedia = (path: string) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-library/media',
    body: { path },
  });
};

const getDetailChannel = (channelId: string) => {
  return fetch({
    method: 'get',
    url: `/api/v1/manage-channel/detail/${channelId}`,
  });
};


/**
 * TODO:
 * please replace channel to your feature name
 * ex:
 * channelApis => bookingApis
 */
const channelApis = {
  getDemoData,
  getListChannels,
  createChannel,
  deleteChannel,
  getListLayouts,
  getListMedia,
  getDetailChannel,
};

export default channelApis;
